import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form, reduxForm } from 'redux-form'
import { Icon, Grid } from '@adc/ui-adc'
import classnames from 'classnames/bind'
import {
  MORE,
  hideEndingSoonSelected,
  allListingTypesSelected,
  activeListingTypeSelected,
  brokerCoopAvailableSelected,
  noBuyerPremiumFilterSelected,
  showReserveSelected,
  maoFilterSelected,
} from '../../../constants/filters'
import MoreFiltersContent from './content'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const { Row, Column } = Grid

export const BASE_ELM_ID = 'more_filters'
export const FORM_NAME = 'moreFilters'

class MoreFiltersForm extends Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    updateFilters: PropTypes.func.isRequired,
    submitForms: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
  }

  submitForms = () => {
    this.props.submitForms(FORM_NAME)
  }

  onClose = () => this.props.onClose(null, { filtername: MORE })

  updateFilters = filters => {
    const newFilters = {
      offset: 0,
      hideEndingSoon: !!filters.hide_ending_soon && hideEndingSoonSelected,
      brokerCoopAvailable:
        !!filters.broker_coop_available && brokerCoopAvailableSelected,
      noBuyerPremiumFilter:
        !!filters.no_buyer_premium_filter && noBuyerPremiumFilterSelected,
      showReserve: !!filters.show_reserve && showReserveSelected,
      presale: !!filters.presale && maoFilterSelected,
      listingType: filters.listing_type
        ? allListingTypesSelected
        : activeListingTypeSelected,
      leasebackRequired: filters.leaseback_required ? 'n' : null,
    }
    this.props.updateFilters(newFilters)
  }

  render() {
    const { handleSubmit, ...rest } = this.props
    return (
      <Form
        className={cx('ui', 'form', 'extra-compact')}
        data-elm-id={`${BASE_ELM_ID}_form`}
        onSubmit={handleSubmit(this.updateFilters)}
      >
        <Row>
          <Column className={cx('filter-close-button')}>
            <Icon
              data-elm-id={`${BASE_ELM_ID}_close_button`}
              className={cx('u-pointer-cursor')}
              onClick={this.onClose}
              iconStyle='light'
              name='times'
              fitted
            />
          </Column>
        </Row>
        <MoreFiltersContent
          {...rest}
          elmId={BASE_ELM_ID}
          className={cx('filter-root')}
          submitForms={this.submitForms}
        />
      </Form>
    )
  }
}

export default reduxForm({
  form: FORM_NAME,
  enableReinitialize: true,
})(MoreFiltersForm)
